<template>
  <div v-if="owner">
    <p class="small text-muted">
      Ces réglages s'appliquent à tous les véhicules de
      {{ owner.user && owner.user.full_name ? owner.user.full_name : "ce propriétaire" }}.
    </p>
    <b-form-checkbox v-model="owner.allows_declared_expenses" switch class="mb-3">
      Les membres peuvent déclarer des dépenses
      <div class="small text-muted font-weight-normal">
        Une dépense déclarée à la main entre dans le calcul de qui doit quoi.
      </div>
    </b-form-checkbox>
    <b-form-checkbox v-model="owner.allows_general_interest_trips" switch class="mb-3">
      Trajets pro ou d'intérêt général
      <div class="small text-muted font-weight-normal">
        L'emprunteur peut indiquer qu'un trajet n'est pas facturé. La raison de l'utilisation est alors obligatoire.
      </div>
    </b-form-checkbox>
    <b-form-group
      label="Durée maximale d'un emprunt"
      label-for="max_loan_days"
      description="Le jour du départ compte pour 1, plus chaque nuit, quelle que soit l'heure de restitution. 1 signifie que le véhicule doit être rendu au plus tard à minuit."
    >
      <b-input-group append="jours" class="max-loan-days">
        <b-form-input
          id="max_loan_days"
          v-model.number="owner.max_loan_days"
          type="number"
          min="1"
          step="1"
        />
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import { positiveIntOrNull } from "@/loanDays";

export default {
  name: "OwnerSettings",
  props: {
    owner: {
      type: Object,
      default: null,
    },
  },
  watch: {
    owner: {
      immediate: true,
      handler(owner) {
        if (!owner) {
          return;
        }
        if (typeof owner.allows_declared_expenses !== "boolean") {
          this.$set(
            owner,
            "allows_declared_expenses",
            this.asBool(owner.allows_declared_expenses, true)
          );
        }
        if (typeof owner.allows_general_interest_trips !== "boolean") {
          this.$set(
            owner,
            "allows_general_interest_trips",
            this.asBool(owner.allows_general_interest_trips, false)
          );
        }
        if (positiveIntOrNull(owner.max_loan_days) === null) {
          this.$set(owner, "max_loan_days", 3);
        }
      },
    },
  },
  methods: {
    asBool(value, fallback) {
      if (value === true || value === 1 || value === "1" || value === "true") {
        return true;
      }
      if (value === false || value === 0 || value === "0" || value === "false") {
        return false;
      }
      return fallback;
    },
  },
};
</script>

<style scoped>
.max-loan-days {
  max-width: 12rem;
}
</style>
